import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { firstValueFrom } from 'rxjs';
import { selectIsAuthenticated } from '../store/auth.selectors';

export const authGuard: CanActivateFn = async (): Promise<boolean> => {
  const store = inject(Store);
  const router = inject(Router);
  const oauthService = inject(OAuthService);

  const isAuthenticatedInStore = await firstValueFrom(store.select(selectIsAuthenticated));

  if (isAuthenticatedInStore || oauthService.hasValidAccessToken()) {
    return true;
  }

  await router.navigate(['/signin'], { replaceUrl: true });
  return false;
};
